import { Routes, Route } from "react-router-dom";

import { FoxgloveIntegration } from "./FoxgloveIntegration";
import { S3Integration } from "./S3Integration";
import { SlackIntegration } from "./SlackIntegration";

export function IntegrationsRoutes() {
  return (
    <Routes>
      <Route path="foxglove" element={<FoxgloveIntegration />} />
      <Route path="s3" element={<S3Integration />} />
      {/* Registered at every tier: the server enforces premium on connect, so a downgraded
          org keeps a page where it can still see and disconnect its workspaces. Slack's OAuth
          callback is NOT here — it needs a loader, so it lives in the data router itself. */}
      <Route path="slack" element={<SlackIntegration />} />
    </Routes>
  );
}
